import intersection from 'lodash/intersection';
export default function shouldShowRowByExpanded(expandedRowKeys, parentKeys) {
  if (expandedRowKeys === void 0) {
    expandedRowKeys = [];
  }

  if (parentKeys === void 0) {
    parentKeys = [];
  }

  var intersectionKeys = intersection(expandedRowKeys, parentKeys);

  if (intersectionKeys.length === parentKeys.length) {
    return true;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite-table/es/utils/shouldShowRowByExpanded.js
// module id = 2138
// module chunks = 31